import { Component, OnInit } from '@angular/core';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {MatDialog, MatDialogRef} from '@angular/material';
import {KongService} from '../kong.service';
import {ConfService} from '../conf.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AppComponent} from '../app.component';
import {UseExistingTableConfirmationComponent} from '../crudapi/crudapi.component';
import {WebsocketService} from '../websocket.service';
import {environment} from '../../environments/environment';
import {JwtParserService} from '../jwt-parser.service';
import {AuthService} from '../user/auth.service';
import {AccountInfoService} from '../user/account-info.service';

@Component({
  selector: 'app-authenticator',
  templateUrl: './authenticator.component.html',
  styleUrls: ['./authenticator.component.scss']
})
export class AuthenticatorComponent implements OnInit {

  emailIDViaToken: any;
  apiKeys: any;
  apiKeyData: any;
  apiKey: any;
  navigate: any;

  constructor(public dialog: MatDialog,
              private kong: KongService,
              private confPost: ConfService,
              private route: ActivatedRoute,
              public platform: LeftpanelComponent,
              private authService: AuthService,
              public accountInfoService: AccountInfoService,
              public router: Router,
              private appComp: AppComponent,
              private Urlroute: ActivatedRoute,
              private webSocketService: WebsocketService,
              private jwtParser: JwtParserService) {
    this.Urlroute.queryParams
        .subscribe(params => {
          if (params.token) {
            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
              width: 'auto',
              height: 'auto',
              data: {
                message: 'Please wait while we logging you in...'
              }
            });
            Promise.resolve(this.authService.validateAndSaveAuthenticatorToken(params.token).then(async response => {
              this.getApiKeyForUser(this.accountInfoService.email);
              loaderDialog.close();
              this.router.navigateByUrl('/console');
            }, error => {
              this.router.navigateByUrl('/auth/login');
              loaderDialog.close();
              this.platform.openSnackBar(error, 'Error', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
            }));
          } else {
            this.platform.openSnackBar('Error while logging you in. Please login again.', 'Error', {
              duration: 3000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
            window.location.href = environment.platformRedirectURL + '/auth/login';
          }
        });
  }

  ngOnInit() {
  }

  validateLogin(loaderDialog: MatDialogRef<LoaderWithProgressComponent>, loginPayload) {
    return new Promise((resolve, reject) => {
      this.confPost.validateLogin(loginPayload).subscribe(resp => {
        if (resp.status === 200) {
          if (resp.body != null) {
            this.confPost.getUserDetailsOnSuccessfulLogin(loginPayload['environment'], loginPayload['environment']).subscribe(data => {
              if (data.status === 200) {
                if (data.body !== null) {

                  this.confPost.getPartnerByName(data.body[0].partner).subscribe(response3 => {
                    const responseFromApi1 = response3;
                    const payload = {
                      'partner': data.body[0].partner,
                      'last_login': Date.now(),
                      'primary': responseFromApi1['primary'],
                      'isActive': responseFromApi1['isActive']
                    };
                    this.confPost.updatePartner(payload).subscribe(response1 => {
                    }, error => {
                      this.platform.notifyErrorToAdmins({error: 'Error occurred while updating last login for the partner ' + data.body[0].partner + ' with timestamp : ' + Date.now()}, 'lastlogin_update_notifyerrortoadmins_success', 'lastlogin_update_notifyerrortoadmins_success', 'Error occurred while updating last login for the partner ' + data.body[0].partner + ' with timestamp : ' + Date.now(), {});
                    });
                  });

                  localStorage.setItem('JWTToken', resp['body']['token']);
                  localStorage.setItem('Auth', 'true');
                  localStorage.setItem('partnerId', data.body[0]._id);
                  localStorage.setItem('partner', data.body[0].partner);
                  localStorage.setItem('partnerKey', data.body[0].partnerKey);
                  localStorage.setItem('currentPlan', data.body[0].currentPlan);
                  localStorage.setItem('currentPlanDisplayName', data.body[0].currentPlanDisplayName);
                  localStorage.setItem('account', data.body[0].accounts[0].account_id !== undefined ? data.body[0].accounts[0].account_id : data.body[0].partner);
                  this.appComp.loggedIn.emit(true);

                  this.webSocketService.initializeWebSocketConnection(loginPayload['ralam'], loginPayload['emailId'], loginPayload['environment'], loginPayload['password'], loginPayload['shash']);

                  const emailLoggedIn = this.emailIDViaToken;

                  localStorage.setItem('signInEmail', emailLoggedIn);
                  this.getApiKeyForUser(emailLoggedIn);
                  loaderDialog.close();
                  resolve('success');
                } else {
                  this.platform.openSnackBar('Error while logging you in. Sorry for the inconvenience. Please login again.', 'Error', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                  });
                  loaderDialog.close();
                  this.router.navigateByUrl('/auth/login');
                  resolve('failed');
                }
              } else {
                this.platform.openSnackBar('Error while logging you in. Sorry for the inconvenience. Please login again.', 'Error', {
                  duration: 3000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
                loaderDialog.close();
                this.router.navigateByUrl('/auth/login');
                resolve('failed');
              }
            }, error => {
              this.platform.openSnackBar('Error while logging you in. Sorry for the inconvenience. Please login again.', 'Error', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
              loaderDialog.close();
              this.router.navigateByUrl('/auth/login');
              resolve('failed');
            });
          } else {
            this.platform.openSnackBar('Error while logging you in. Sorry for the inconvenience. Please login again.', 'Error', {
              duration: 3000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
            loaderDialog.close();
            this.router.navigateByUrl('/auth/login');
            resolve('failed');
          }
        } else {
          this.platform.openSnackBar('Error while logging you in. Sorry for the inconvenience. Please login again.', 'Error', {
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          loaderDialog.close();
          this.router.navigateByUrl('/auth/login');
          resolve('failed');
        }
      }, error => {
        this.platform.openSnackBar('Error while logging you in. Sorry for the inconvenience. Please login again.', 'Error', {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        loaderDialog.close();
        this.router.navigateByUrl('/auth/login');
      });
    });
  }

  public getPage() {
    this.route.queryParams
        .subscribe(params => {
          this.navigate = params.return;
        });
    if (this.navigate) {
      this.router.navigate([this.navigate]);
    } else {
      this.router.navigate(['/console']);
    }
  }

  getApiKeyForUser(signInEmail) {
    return new Promise((resolve, reject) => {
      this.kong.getKeyAuthForConsumerInApiGatewayByNameOrId(signInEmail).subscribe(keys => {
        this.apiKeyData = keys;
        if (this.apiKeyData.data !== null && this.apiKeyData.data !== undefined && this.apiKeyData.data.length !== 0) {
          this.apiKeys = this.apiKeyData.data;
          this.apiKey = this.apiKeys[0].key;
          localStorage.setItem('apikey', this.apiKey);
          this.getPage();
        } else {
          this.getPage();
          this.platform.openSnackBar('There is no API key associated to your user credentials. Please get an API Key to securely access your APIs.', 'Info', {
            duration: 10000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
        resolve('success');
      }, error => {
        this.getPage();
        this.platform.openSnackBar('There is no API key associated to your user credentials. Please get an API Key to securely access your APIs.', 'Info', {
          duration: 10000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        resolve('failed');
      });
    });
  }

}
